import * as ko from 'knockout';

import {BaseScreen} from 'Core/Screens/BaseScreen';
import {SearchScreen} from 'Core/Screens/SearchScreen/SearchScreen';
import {ISearchScreenParam} from 'Core/Screens/IScreen';
import {ScreenModel} from 'Core/Models/Screens/ScreenModel';
import {IControlValue} from 'Core/Controls/BaseControl/BaseControl';
import {IControl} from 'Core/Controls/IControl';
import {CONTROL_TYPES, RenderModes} from 'Core/Constant';
import {TypeScreen} from 'Core/Screens/TypeScreen/TypeScreen';
import {EditScreen} from 'Core/Screens/EditScreen/EditScreen';
import {ScreenManager} from 'Core/ScreenManager/ScreenManager';
import {Notifier} from 'Core/Common/Notifier';
import {MenuManager} from 'MenuManager/MenuManager';
import {ScreenTypes} from 'Core/Common/Enums/ScreenTypes';
import {Grid} from 'Core/Controls/Grid/Grid';
import {ControlDataModel} from 'Core/ScreenManager/Models/ControlDataModel';
import {RecordSpecsModel} from 'Core/ScreenManager/Models/RecordSpecsModel';
import {PUB_SUB_EVENTS} from 'MenuManager/PubSubEvents';
import {NOTIFICATIONS, LABELS} from 'Core/Components/Translation/Locales';
import ListScreenTemplate from 'Core/Screens/Templates/AdditionalConsultScreen/ListScreen/ListScreen.html';
import {LockManager} from 'Core/Components/Locker/LockManager';
import {UserVarsManager} from 'Core/UserVarsManager/UserVarsManager';
import {ProfileSelectorScreen} from '../ProfileSelectorScreen/ProfileSelectorScreen';

ko.templates['Core/Screens/Templates/AdditionalConsultScreen/ListScreen/ListScreen'] = ListScreenTemplate;

export class ListScreen extends BaseScreen {
    private _grid: Grid;

    constructor(screenModel: ScreenModel) {
        super(screenModel, RenderModes.Edit);

        this.Init();
    }

    private Init() {
        this._grid = this.GetControl<Grid>('Grid');

        if (this._grid) {
            ['EnableLinkButton', 'EnableAdd&LinkButton', 'EnableAddQueryButton']
                .forEach(property => this._grid.ChangeProperty(property, false));
        }

        if (!this._model.Data) {
            return;
        }

        const controlData = new ControlDataModel();

        controlData.Rights = this._model.Data.Rights;

        const controlValue: IControlValue = {
            Data: controlData,
            SubjectEntityId: this._model.EntityId,
            SubjectRecordId: -1,
            RecordSpecsModel: null
        };
        
        _.each(this.GetAllControls(), (control: IControl) => { 
            control.SetValue(controlValue);
        });
        
        this.On('SEARCH_RECORD', this, (eventArgs: any) => this.SearchRecord());
        this.On('ADD_RECORD', this, (eventArgs: any) => this.CreateRecord());
    }

    Refresh() {
        this._grid.LoadData();
    }

    GetTemplateName(): string {
        return `Core/Screens/Templates/AdditionalConsultScreen/ListScreen/ListScreen`;
    }

    GetTextSearchTermControl(): IControl {
        return _.first(_.filter(this.GetAllControls(), (control: IControl) => control.GetType() === 'Search'));
    }

    SearchRecord(): void {
        LockManager.Instance.ReleaseAllLocks();
        const SearchControl = this.GetTextSearchTermControl();
        const searchControlId = SearchControl != null ? SearchControl.GetControlId() : 0;
        const searchTerm = SearchControl ? SearchControl.GetValue() : '';

        const searchParams: ISearchScreenParam = {
            EntityId: this.GetEntityId(),
            ControlId: searchControlId,
            SearchTerm: searchTerm
        };

        const searchScreen = new SearchScreen(searchParams);

        searchScreen.On('RECORD_SELECTED', this, (eventArgs: any) => {
            UserVarsManager.Instance.AddRecent(this.GetEntityId(), eventArgs.data.RecordId, eventArgs.data.TypeId);

            searchScreen.Close();

            PubSub.publish(PUB_SUB_EVENTS.GO_TO_RECORD_SCREEN, {
                EntityId: this.GetEntityId(),
                RecordId: eventArgs.data.RecordId,
                RecordTypeId: eventArgs.data.TypeId
            });
        });

        searchScreen.On('ALT_ENTITY_RECORD_SELECTED', this, (eventArgs) => {
            const data = eventArgs.data;

            UserVarsManager.Instance.AddRecent(data.EntityId, data.RecordId, data.TypeId);
            data.IsOpenInModal = false;
            PubSub.publish(PUB_SUB_EVENTS.GO_TO_RECORD_SCREEN, data);
        });


        searchScreen.On('NEW_RECORD', this, (eventArgs) => {
            const showTypeSelector = () => {
                const typeScreen = new TypeScreen(this.GetEntityId(), this.GetTableTypeId(), true);

                typeScreen.On('TYPES_NOT_FOUND', this, (eventArgs) => new Notifier().Warning(eventArgs.data.Message || NOTIFICATIONS.TYPES_NOT_FOUND));
                typeScreen.On('TYPE_SELECTED', this, (eventArgs) => {

                    const typeId = eventArgs.data.TypeId;
                    const kindId = eventArgs.data.KindId;
                    const exampleRecordId = eventArgs.data.ExampleRecordId;

                    searchScreen.Cancel();
                    this.NewRecord(typeId, kindId, exampleRecordId, searchScreen.SearchTerm());
                });

                typeScreen.Show();
            }

            if (this.IsInModal()) {
                showTypeSelector();
                return;
            }

			const profileSelectorScreen = new ProfileSelectorScreen(this.GetEntityId(), this.GetEntityName());

            profileSelectorScreen
                .On('PROFILES_NOT_FOUND', this, () => {
                    new Notifier().Warning('Profiles with create possibilities not found');
                })
                .On('PROFILE_SELECTION_CANCELLED', this, () => {
                    profileSelectorScreen.Close();
                })
                .On('PROFILE_SELECTED', this, () => {
                    profileSelectorScreen.Close();
                    searchScreen.Cancel();
                    showTypeSelector();
                })
                .On('USED_CURRENT_PROFILE', this, () => {
                    profileSelectorScreen.Close();
                    showTypeSelector();
                });

            profileSelectorScreen.ShowIfNeeded();
        });

        searchScreen.Show();
    }

    EditRecord(): void {

    }

    NewRecord(tableTypeId: number, kindId: number, exampleRecordId: number, searchTerm?: string) {
        ScreenManager.GetEditScreen({
            EntityId: this.GetEntityId(),
            TableTypeId: tableTypeId,
            KindId: kindId,
            RecordId: exampleRecordId,
            LoadAsExample: exampleRecordId > 0
        })
            .fail((err) => {
                var notifier = new Notifier();
                notifier.Failed(err.message);
            })
            .then((screen: EditScreen) => {
                if (!screen) {
                    new Notifier($(this._el)).Warning(NOTIFICATIONS.EDIT_SCREEN_NOT_EXISTS);

                    return;
                }

                LockManager.Instance.ReleaseAllLocks();
                const editScreen = screen;

                editScreen.IsDataFromExample = exampleRecordId > 0;
                editScreen.ParentRecordId = this.GetRecordId();
                editScreen.UseLinking = true;

                if (searchTerm) {
                    this.NameControlSetValue(editScreen, searchTerm);
                }

                screen.On('RECORD_SAVED', this, (eventArgs) => {
                    const notifier = new Notifier($(this._el));
                    notifier.Success(NOTIFICATIONS.RECORD_CREATED);
                    this.LoadData(eventArgs.data.RecordId, tableTypeId);
                });

                screen.ShowInModal();
            });
    }

    CreateRecord() {
        const showTypeSelector = () => {
            const typeScreen = new TypeScreen(this.GetEntityId(), this.GetTableTypeId(), true);

            const SearchControl = this.GetTextSearchTermControl();
            const searchTerm = SearchControl ? SearchControl.GetValue() : '';

            typeScreen.On('TYPES_NOT_FOUND', this, (eventArgs) => new Notifier().Warning(eventArgs.data.Message || NOTIFICATIONS.TYPES_NOT_FOUND));

            typeScreen.On('TYPE_SELECTED', this, (eventArgs) => {
                const typeId = eventArgs.data.TypeId;
                const kindId = eventArgs.data.KindId;
                const exampleRecordId = eventArgs.data.ExampleRecordId;

                this.NewRecord(typeId, kindId, exampleRecordId, searchTerm);
            });

            typeScreen.Show();
        }

        if (this.IsInModal()) {
            showTypeSelector();
            return;
        }

		const profileSelectorScreen = new ProfileSelectorScreen(this.GetEntityId(), this.GetEntityName());

        profileSelectorScreen
            .On('PROFILES_NOT_FOUND', this, () => {
                new Notifier().Warning('Profiles with create possibilities not found');
            })
            .On('PROFILE_SELECTION_CANCELLED', this, () => {
                profileSelectorScreen.Close();
            })
            .On('PROFILE_SELECTED', this, () => {
                profileSelectorScreen.Close();
                showTypeSelector();
            })
            .On('USED_CURRENT_PROFILE', this, () => {
                profileSelectorScreen.Close();
                showTypeSelector();
            });

        profileSelectorScreen.ShowIfNeeded();
    }

    LoadData(recordId: number, tableTypeId: number) {
        this.LoadScreenFor(tableTypeId, recordId);
    }

    LoadScreenFor(tableTypeId: number, recordId: number) {
        if (this.IsDashMain) {
            this._grid.UpdateTableViewList();
        } else {
            ScreenManager.GetScreenByScreenType(this.GetEntityId(), ScreenTypes.ConsultScreen, recordId)
                .then(screen => {
                    screen.SetIsReady(true);
                    MenuManager.Instance.GoToScreen(screen);
                })
                .fail(err => {
                    new Notifier().Warning(err.message);

                });
        }
    }

    private NameControlSetValue(screen: EditScreen, value: string) {
        const control = screen.GetControlByFieldName('NAME', CONTROL_TYPES.Text);

        if (control) {
            const controlData = new ControlDataModel();

            controlData.FieldId = control.FieldModel.Id;
            controlData.Value = value;
            controlData.DisplayValue = value;

            const controlValue: IControlValue = {
                Data: controlData,
                SubjectEntityId: this._model.EntityId,
                SubjectRecordId: this._recordId,
                RecordSpecsModel: new RecordSpecsModel()
            };

            control.SetDefaultValue(controlValue);
        }
    }

    AfterRender(el) {
        super.AfterRender(el);
        this.SetScreenStyle();
    }

} 